import React, { useState } from 'react';
import { TextField, InputAdornment } from '@mui/material';

const MaxPriceAllowed = (productCategory, btnSelected) => {
  if (btnSelected === 'meal_item') {
    // eslint-disable-next-line default-case
    switch (productCategory) {
      case 'main_dish':
        return 9.99;
      case 'side':
        return 5.0;
      case 'starter':
        return 5.0;
      case 'complementary':
        return 0.0;
      case 'drink or dessert or treat':
        return 0.0;
    }
  }
};

export default function PriceInput(props) {
  const { price, setPrice, btnSelected, productCategory, submitError } = props;
  const [error, setError] = useState('');

  const formatPrice = (raw) => {
    const digitsOnly = raw.replace(/\D/g, '');
    if (digitsOnly.length === 0) return '0.00';
    const padded = digitsOnly.padStart(3, '0');
    const intPart = padded.slice(0, -2);
    const decimalPart = padded.slice(-2);
    return `${parseInt(intPart, 10)}.${decimalPart}`;
  };

  const handleChange = (e) => {
    const input = e.target.value;
    const digitsOnly = input.replace(/\D/g, '');

    if (digitsOnly.length > 5) return; // Prevent long input like "123456"

    const formatted = formatPrice(digitsOnly);

    if (formatted > MaxPriceAllowed(productCategory, btnSelected)) {
      setError(true);
    } else {
      setError('');
    }

    setPrice(formatted);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <TextField
        label='Amount'
        variant='outlined'
        fullWidth
        value={formatPrice(price)}
        onChange={handleChange}
        error={!!error || !!submitError}
        helperText={
          submitError || (error && `Max $${MaxPriceAllowed(productCategory, btnSelected)}`)
        }
        disabled={productCategory === 'select'}
        inputProps={{
          inputMode: 'decimal',
          pattern: '^\\d+(\\.\\d{0,2})?$',
        }}
        InputLabelProps={{
          sx: {
            color: 'gray',
            '&.Mui-focused': {
              color: 'rgb(255, 123, 41)',
            },
          },
        }}
        InputProps={{
          startAdornment: <InputAdornment position='start'>$</InputAdornment>,
        }}
        sx={{
          marginBottom: '13px',
          width: '110px',
          '& .MuiOutlinedInput-root': {
            borderRadius: 1,
            backgroundColor: '#fff',
            width: '100px',
            '& fieldset': {
              borderColor: '#ccc',
            },
            '&:hover fieldset': {
              borderColor: '#181436',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#181436',
              // boxShadow: '0 0 0 2px rgba(255, 87, 34, 0.2)',
            },
            '&.Mui-error fieldset': {
              borderColor: 'red',
            },
          },
          '& input': {
            fontSize: '16px',
            padding: '8px',
          },
        }}
      />
      <div></div>
    </div>
  );
}
